export const getMemberFavourites = (state) => state.memberFavourites?.memberFavourites;
export const getMemberFavouritesStatus = (state) => state.memberFavourites.status;
export const getMemberFavouritesError = (state) => state.memberFavourites?.error;
